import {
  Component,
  Input,
  EventEmitter,
  Output,
  NgZone,
  ViewChild,
  TemplateRef,
} from '@angular/core';
import { FormioCustomComponent } from 'angular-formio';
import { HeartlandObserverService } from '../../../../services/heartland-observer.service';
import { FormObserverService } from '../../../../services/form-observer.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { ACHPayment } from '../../../../../shared/models/invoice/ach-payment.model';
import { Settings } from '../../../../../shared/models/settings/settings.model';
import { embedPaymentCss } from '../../../../models/globalpayments.model';
import { AchTcComponent } from '../../../../../shared/components/payment/ach-payment/ach-tc/ach-tc.component';
import {
  AccountType,
  CheckType,
} from '../../../../../shared/models/invoice/payment.model';
import { LocationSwitchService } from '../../../../../shared/services/location-switch.service';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe-decorator';
import { GooglePayButtonComponent } from '../../../../../shared/components/google-pay-button/google-pay-button.component';
import { TermsconditionpolicyService } from 'src/app/shared/services/termsconditionpolicy.service';

declare var GlobalPayments: any;
@Component({
  selector: 'app-heartland-payment',
  templateUrl: './heartland-payment.component.html',
  styleUrls: ['./heartland-payment.component.scss'],
})
export class HeartlandPaymentComponent
  implements FormioCustomComponent<object>
{
  @ViewChild(GooglePayButtonComponent, { static: false })
  googlePayButtonComponent: GooglePayButtonComponent;

  @ViewChild('container', { static: false }) tcpTemplate: TemplateRef<any>;

  @Input() source: string = '';
  @Input() locationId: any;
  @Input() paymentType: string;
  @Input() paymentTypes: any; // new version with multiple selection of payment methods
  @Input() value: object;
  @Input() disabled: boolean;
  @Input() moduleType: string = null;

  @Output() valueChange = new EventEmitter<object>();
  @Output() tokenData = new EventEmitter();

  amount: number;
  invoiceNumber: string;
  hps: any;
  publicAPIKey: string;
  locationData: any;
  saveCard: boolean = false;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  regEx: any =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  displayType: string;
  isACHEnabled: boolean = false;
  isCCEnabled: boolean = false;
  isGooglePayEnabled: boolean = false;
  isApplePayEnabled: boolean = false;
  isThirdPartyEnabled: boolean = false;
  // isRequireTermsPolicy: boolean = false;
  isShowRememberCard: boolean = false;
  agreedToTerms: boolean = false;
  isCheckingAccount: boolean = true;
  merchantName: string = '';
  contactNumber: string = '';

  achPaymentModel: ACHPayment = new ACHPayment();
  paymentFormInfo: Object;
  isEmbed: boolean = true;

  isRecurringForm: boolean = false;
  cardForm: any;
  isFormValid: boolean = false;

  hasCommercialItem: boolean = false;

  // Third Party T&C
  currentModal: NgbModalRef;
  tcpTitle: string;
  tcpContent: string;
  policyContent: string;
  termsAndConditionContent: string;

  activeThirdParties: string[] = [];
  activePaymentMethodsCounter: number = 0;

  @AutoUnsubscribe()
  private castamount$: Subscription;
  @AutoUnsubscribe()
  private castIsRecurringForm$: Subscription;
  @AutoUnsubscribe()
  private castBusinessData$: Subscription;
  @AutoUnsubscribe()
  private castFormvalidation$: Subscription;
  @AutoUnsubscribe()
  private castHasCommercialItem$: Subscription;

  constructor(
    private locationSwitchService: LocationSwitchService,
    private heartlandObserverService: HeartlandObserverService,
    private formObserverService: FormObserverService,
    private modalService: NgbModal,
    private _ngZone: NgZone,
    private router: Router,
    private tcpService: TermsconditionpolicyService
  ) {}

  ngOnInit(): void {
    if (this.router.url.indexOf('portal/') !== -1) {
      this.isEmbed = false;
    }

    if (this.moduleType == 'subscriptionModule') {
      this.saveCard = true;
    } else {
      let saveCardDefaultValue = this.formObserverService.castProperty(
        'heartlandpayment',
        'customOptions.saveCardDefault'
      );
      if (typeof saveCardDefaultValue === 'boolean') {
        this.saveCard = saveCardDefaultValue;
      }

      let showSaveCard = this.formObserverService.castProperty(
        'heartlandpayment',
        'customOptions.enableSaveCard'
      );
      if (typeof showSaveCard === 'boolean') {
        this.isShowRememberCard = showSaveCard;
      }
    }

    // Get the location ID defined in the Property
    let locationIdValue = this.formObserverService.castProperty(
      'heartlandpayment',
      'customOptions.locationId'
    );
    if (typeof locationIdValue === 'number') {
      this.locationId = locationIdValue;
    }

    // new version
    let displayTypeOptions = this.formObserverService.castProperty(
      'heartlandpayment',
      'customOptions.paymentTypes'
    );
    if (typeof displayTypeOptions === 'object') {
      this.paymentTypes = displayTypeOptions;
    }

    let requireTermsPolicy = this.formObserverService.castProperty(
      'heartlandpayment',
      'customOptions.requireTermsPolicy'
    );
    // if (typeof requireTermsPolicy === 'boolean') {
    //   this.isRequireTermsPolicy = requireTermsPolicy;
    // }
    this.getThirdPartyTermsPolicy();

    setTimeout(() => {
      this.initPaymentForm();
    }, 2000);
  }

  initializeObservables() {
    this.castamount$ = this.heartlandObserverService.castamount.subscribe(
      (amount) => {
        this.amount = amount;
        this.googlePayButtonComponent?.setAmount(amount);
      }
    );

    let hasRecurringForm: boolean = false;
    let hasL2L3Fields: boolean = false;

    this.castIsRecurringForm$ =
      this.formObserverService.castIsRecurringForm.subscribe((isActive) => {
        hasRecurringForm = isActive;
        this.isRecurringForm = isActive;
      });

    this.castHasCommercialItem$ =
      this.formObserverService.castHasCommercialItem.subscribe((isActive) => {
        hasL2L3Fields = isActive;
        this.hasCommercialItem = isActive;
      });

    this.castBusinessData$ =
      this.formObserverService.castBusinessData.subscribe(
        (businessData: Settings) => {
          this.merchantName = businessData.BusinessName;
          this.contactNumber = businessData.ContactNumber;
        }
      );

    this.castFormvalidation$ =
      this.formObserverService.castFormvalidation.subscribe(
        (isFormValid: boolean) => {
          this.isFormValid = isFormValid;
          this.toggleSubmitButton();
        }
      );

    if (!this.saveCard) this.saveCard = hasRecurringForm || hasL2L3Fields;
  }

  processGooglePayResponse(response: Object) {
    const formioBtn: any = document.querySelector("[name='data[submit]']");
    // @ts-ignore
    formioBtn.click();
    this.paymentFormInfo = {
      tokenization: response,
      paymentType: 'google_pay',
      amount: this.amount,
      locationData: this.locationData,
    };

    // this.updateValue(this.paymentFormInfo)
    this.heartlandObserverService.updatePaymentFormInfo(this.paymentFormInfo);
  }

  onACHPaymentSubmission() {
    // ACH Validation and submission
    let warning: boolean = false;
    let warning_message: string = '';
    let error: boolean = false;
    let error_message: string = '';

    let paymentFormData: any = {
      amount: this.amount,
      locationData: this.locationData,
      customerData: {
        saveCard: this.saveCard,
        firstName: this.firstName,
        lastName: this.lastName,
        email: this.email,
        phone: this.phone,
      },
    };

    // Validations for Customer Creation
    // this.isRequireTermsPolicy && 
    if (!this.agreedToTerms) {
      error = true;
      error_message = 'Please Agree to ACH Payment Terms and Conditions..';
    }

    if (this.saveCard) {
      if (!this.email || !this.regEx.test(this.email.toLowerCase())) {
        error = true;
        error_message = 'Email is not valid.';
      }
    } else {
      if (this.email && !this.regEx.test(this.email.toLowerCase())) {
        error = true;
        error_message = 'Email is not valid.';
      }
    }
    if (!this.saveCard && !this.email) {
      warning = true;
      warning_message =
        "You have not provided an email address. You won't be able to receive payment receipts. Proceed anyway?";
    }

    if (!this.firstName || !this.lastName) {
      error = true;
      error_message = 'Check Holder name is required.';
    }
    if (
      this.achPaymentModel.AccountType == 0 &&
      this.achPaymentModel.CheckType == undefined
    ) {
      error = true;
      error_message = 'Check type is required.';
    }
    if (this.achPaymentModel.AccountType == undefined) {
      error = true;
      error_message = 'Account type is required.';
    }

    if (!this.achPaymentModel.RoutingNumber) {
      error = true;
      error_message = 'Routing number is required.';
    }

    if (!this.achPaymentModel.AccountNumber) {
      error = true;
      error_message = 'Account number is required.';
    }

    if (!this.amount) {
      error = true;
      error_message = 'Please enter an Amount.';
    }

    if (!this.isACHEnabled) {
      error = true;
      error_message =
        'ACH is not available at the moment, please contact your Merchant administrator.';
    }

    this.achPaymentModel.CheckHolderName = this.firstName + ' ' + this.lastName;
    this.paymentFormInfo = {
      ...this.paymentFormInfo,
      paymentType: this.displayType,
      achModel: this.achPaymentModel,
      agreedToTerms: this.agreedToTerms,
      amountToBePaid: this.amount,
      paymentFormData: paymentFormData,
      warning: warning,
      warning_message: warning_message,
      error: error,
      error_message: error_message,
    };
    // this.updateValue(this.paymentFormInfo)
    this.heartlandObserverService.updatePaymentFormInfo(this.paymentFormInfo);
  }

  updateValue(payload: object) {
    this.value = payload; // Should be updated first
    this.valueChange.emit(payload); // Should be called after this.value update
  }

  togglePaymentDisplay(type: string) {
    this.agreedToTerms = false;

    const tempDisplayType = this.displayType;
    this.displayType = type;
    this.toggleSubmitButton();
    this.updateValue({ paymentType: this.displayType });

    this._ngZone.run(() => {
      if (type === 'credit_card' && tempDisplayType !== 'credit_card') {
        setTimeout(() => {
          this.renderPaymentForm();
        });
      } else {
        setTimeout(function () {
          if ((window as any).embed) {
            new (window as any).embed.Child({});
          }
        }, 1500);
      }
    });
  }

  renderPaymentForm() {
    let self = this;

    if (!this.isEmbed) {
      return;
    }

    if (this.cardForm) {
      this.cardForm.dispose();
    }

    // Create Form
    this.cardForm = GlobalPayments.ui.form({
      fields: {
        'card-holder-name': {
          placeholder: 'Jane Smith',
          target: '#credit-card-card-holder',
        },
        'card-number': {
          placeholder: '•••• •••• •••• ••••',
          target: '#credit-card-card-number',
        },
        'card-expiration': {
          placeholder: 'MM / YYYY',
          target: '#credit-card-card-expiration',
        },
        'card-cvv': {
          placeholder: '•••',
          target: '#credit-card-card-cvv',
        },
        submit: {
          value: 'Process Payment',
          target: '#credit-card-submit',
        },
      },
      styles: embedPaymentCss(),
    });

    // On Submit button click
    this.cardForm.on('submit', 'click', () => {
      // Trigger FormIO submission
      const formioBtn = document.querySelector("[name='data[submit]']");
      // @ts-ignore
      formioBtn.click();

      // Just preset the initial value to prevent validation error in embed component
      this.heartlandObserverService.updatePaymentFormInfo({
        amount: this.amount,
        paymentType: this.displayType,
        customerData: {
          saveCard: this.saveCard,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          phone: this.phone,
        },
      });

      if (!self.amount) {
        self.heartlandObserverService.updateTokenData({
          error: true,
          error_message: 'Amount is invalid',
        });
        return;
      }

      if (!self.firstName || !self.lastName) {
        self.heartlandObserverService.updateTokenData({
          error: true,
          error_message: 'Card holder name is required.',
        });
        return;
      }

      // Validations for Customer Creation
      if (self.saveCard) {
        if (!self.email || !self.regEx.test(self.email.toLowerCase())) {
          self.heartlandObserverService.updateTokenData({
            error: true,
            error_message: 'Email is not valid',
          });
          return;
        }
      } else {
        if (self.email && !self.regEx.test(self.email.toLowerCase())) {
          self.heartlandObserverService.updateTokenData({
            error: true,
            error_message: 'Email is not valid',
          });
        }
      }
    });

    // On tokenization successful
    this.cardForm.on('card-number', 'token-success', function (res) {
      let tokenData: any = {
        ...{
          token: res.paymentReference,
          lastFour: res.details.cardLast4,
          cardBIN: res.details.cardBin,
          cardType: res.details.cardType,
          expMonth: res.details.expiryMonth,
          expYear: res.details.expiryYear,
        },
        amount: self.amount,
        locationData: self.locationData,
        customerData: {
          saveCard: self.saveCard,
          firstName: self.firstName,
          lastName: self.lastName,
          email: self.email,
          phone: self.phone,
        },
      };
      self.heartlandObserverService.updateTokenData(tokenData);
      self.heartlandObserverService.updateAmountData(self.amount);

      if (!self.saveCard && !self.email) {
        tokenData = {
          ...tokenData,
          error: true,
          error_message: 'E-mail address is not valid.',
        };
      }

      self.heartlandObserverService.updateTokenData(tokenData);
    });

    // On tokenization Failed
    this.cardForm.on('card-number', 'token-error', function (res) {
      self.heartlandObserverService.updateTokenData({
        error: true,
        error_message: res.reasons[0].message,
      });
    });

    // resize the parent iframe when form is already rendered
    setTimeout(function () {
      if ((window as any).embed) {
        new (window as any).embed.Child({});
      }
    }, 1500);
  }

  initPaymentForm() {
    const location: any = this.locationId || 1; // get MAIN if nothing is thrown
    this.locationSwitchService.locations.subscribe((list) => {
      list.map((locationData) => {
        if (locationData.Id === location) {
          this.locationData = locationData;
          this.publicAPIKey = locationData.API_Key;
          this.isACHEnabled = locationData.ACHEnabled && this.paymentTypes.ach;
          this.isCCEnabled =
            locationData.CCEnabled && this.paymentTypes.credit_card;
          this.isGooglePayEnabled =
            locationData.GooglePayEnabled && this.paymentTypes.google_pay;
          this.isApplePayEnabled =
            locationData.ApplePayEnabled && this.paymentTypes.apple_pay;

          if (this.isGooglePayEnabled || this.isApplePayEnabled) {
            this.isThirdPartyEnabled = true;
            this.paymentType = 'third_party';
            this.activePaymentMethodsCounter++;

            if (this.isGooglePayEnabled)
              this.activeThirdParties.push('Google Pay');
            if (this.isApplePayEnabled)
              this.activeThirdParties.push('Apple Pay');
          }

          if (this.isACHEnabled) {
            document
              .querySelector("[name='data[submit]']")
              .addEventListener(
                'click',
                this.onACHPaymentSubmission.bind(this)
              );
            this.paymentType = 'ach';
            this.activePaymentMethodsCounter++;
          }

          if (this.isCCEnabled) {
            GlobalPayments.configure({
              publicApiKey: this.publicAPIKey,
            });

            this.paymentType = 'credit_card';
            this.activePaymentMethodsCounter++;
            this.renderPaymentForm();
          }

          if (this.activePaymentMethodsCounter > 1) {
            this.displayType = undefined;
          } else {
            this.displayType = this.paymentType;
            this.updateValue({ paymentType: this.displayType });
          }

          this.initializeObservables();

          return true;
        }
      });
    });
  }

  toggleSubmitButton() {
    let formioBtn: HTMLElement = document.querySelector(
      "[name='data[submit]']"
    );
    let globalPaymentBtn: HTMLElement =
      document.getElementById('credit-card-submit');
    let globalPaymentFakeBtn: HTMLElement = document.getElementById(
      'credit-card-submit-mask'
    );
    let buttonsContainer: HTMLElement = document.getElementById(
      'formioCounterPartBtnsContainer'
    );

    // @ts-ignore
    buttonsContainer?.className = formioBtn.parentNode?.className;

    // @ts-ignore
    const isFormNotValid = formioBtn.disabled;
    this.isFormValid = !isFormNotValid;

    if (this.displayType === undefined || this.displayType === 'third_party') {
      // @ts-ignore
      formioBtn.style.display = 'none';
      // @ts-ignore
      globalPaymentFakeBtn.style.display = 'none';
      // @ts-ignore
      globalPaymentBtn.style.visibility = 'hidden';
    } else {
      if (this.displayType === 'credit_card' && this.isCCEnabled) {
        // @ts-ignore
        formioBtn.style.display = 'none';

        if (isFormNotValid) {
          // If form is not valid, we display the fake button
          globalPaymentBtn.style.visibility = 'hidden';
          globalPaymentFakeBtn.style.display = '';
          // @ts-ignore
          globalPaymentFakeBtn?.className = formioBtn?.className;
        } else {
          // display the iFrame Button
          // @ts-ignore
          globalPaymentBtn?.className = formioBtn?.className
            ?.replace('btn', '')
            ?.replace('btn-mid', '')
            ?.replace('btn-primary', '');
          globalPaymentBtn.style.visibility = 'visible';
          globalPaymentFakeBtn.style.display = 'none';
        }
      } else {
        // @ts-ignore
        formioBtn?.style.display = '';
        if (globalPaymentBtn && globalPaymentFakeBtn) {
          globalPaymentBtn.style.visibility = 'hidden';
          globalPaymentFakeBtn.style.display = 'none';
        }
      }
    }
  }

  onMobileNumberKeyup(event) {
    let formattedMobileNumber = event;

    if (event != '') {
      if (event.length > 2) {
        if (event.indexOf('(') < 0) {
          formattedMobileNumber = '(' + event[0] + event[1] + event[2] + ')';
        }
        if (event.length == 8) {
          formattedMobileNumber =
            formattedMobileNumber.slice(0, 5) +
            ' ' +
            formattedMobileNumber[5] +
            formattedMobileNumber[6] +
            formattedMobileNumber[7] +
            '-';
        }
        this.phone = formattedMobileNumber;
      } else {
        this.phone = event;
      }
    }
  }

  openTermsAndCondition() {
    let achTerms = this.modalService.open(AchTcComponent, { size: 'lg' });
    achTerms.componentInstance.merchantName = this.merchantName;
    achTerms.componentInstance.contactNumber = this.contactNumber;
  }

  accountTypeChanged(event: any) {
    this.achPaymentModel.AccountType =
      event.target.value === '0' ? AccountType.CHECKING : AccountType.SAVINGS;
    this.isCheckingAccount = event.target.value === '0';
  }

  checkTypeChanged(event: any) {
    const chktype = event.target.value;
    if (chktype === '0') {
      this.achPaymentModel.CheckType = CheckType.PERSONAL;
    } else if (chktype === '1') {
      this.achPaymentModel.CheckType = CheckType.BUSINESS;
    } else if (chktype === '2') {
      this.achPaymentModel.CheckType = CheckType.PAYROLL;
    } else {
      this.achPaymentModel.CheckType = null;
    }
  }

  // Third Party Functions
  private getThirdPartyTermsPolicy() {
    this.tcpService.getTerms().subscribe((res: any) => {
      if (res) {
        let term = res.filter((item) => {
          return item.Type === 1 && item.IsDefault;
        })[0];

        let policy = res.filter((item) => {
          return item.Type === 2 && item.IsDefault;
        })[0];

        if (term) {
          this.termsAndConditionContent = term.Content;
        }

        if (policy) {
          this.policyContent = policy.Content;
        }
      }
    });
  }

  openThirdPartyTermsAndCondition() {
    this.tcpTitle = 'Terms and Conditions';
    this.tcpContent = this.termsAndConditionContent;
    this.currentModal = this.modalService.open(this.tcpTemplate, {
      size: 'lg',
    });
  }

  openThirdPartyPolicy() {
    this.tcpTitle = 'Policy';
    this.tcpContent = this.policyContent;
    this.currentModal = this.modalService.open(this.tcpTemplate, {
      size: 'lg',
    });
  }

  closeCurrentDialog() {
    this.currentModal.close();
  }
}
